import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { OrganisationGroup } from 'api/httpEntities';
import OrganisationGroupLink from 'components/OrganisationGroupLink/OrganisationGroupLink';
import { styled, SxProps, Theme } from '@mui/material';

const TranslationContainer = styled('div')(({ theme }) => ({
  display: 'inline-block',
  margin: `${theme.spacing(spacingSizeMap.XS)} 0`,
  maxWidth: '100%',
  textAlign: 'center',
  wordBreak: 'break-word',
}));

const ParentGroupLink = ({
  group,
  sx,
}: {
  group: OrganisationGroup;
  sx?: SxProps<Theme>;
}) => (
  <TranslationContainer sx={sx}>
    <OrganisationGroupLink group={group} kind="orgCard" />
  </TranslationContainer>
);

export default ParentGroupLink;
